import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type Input = ApiDefinition['/creators/{creatorId}/creditors/{creditorId}']['DELETE']['params'];
type Output = ApiDefinition['/creators/{creatorId}/creditors/{creditorId}']['DELETE']['response'];

const deleteCreatorCreditor = async ({ creatorId, creditorId }: Input): Promise<Output> => {
  const data = await noodleApiClient.delete(`/creators/${creatorId}/creditors/${creditorId}`);
  return data.data;
};

export default deleteCreatorCreditor;
